<template>
  <div>
    <div class="ui labeled icon menu">
      <a class="item" @click="print">
        <i class="print icon"></i>
        {{ $t("print") }}
      </a>
      <a class="item" @click="update">
        <i class="lightning icon"></i>
        {{ $t("update") }}
      </a>
    </div>
    <div id="print_element"><div ref="preview_component"></div></div>

    <!-- <div class="ui orange icon labeled button">
      <i class="print icon"></i> {{ $t("print") }}
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import PHE from "print-html-element";

export default {
  name: "QuotationModalPreview",
  components: {},
  props: { quotation_in: Object, setup: Object },
  data() {
    return {
      vueObject: undefined,
    };
  },
  methods: {
    render(template) {
      let vm = this;
      let mixin = {};
      try {
        if (template.js) eval(`mixin = ${template.js}`);
      } catch (ex) {
        console.error(ex);
      }

      vm.vueObject = new Vue({
        template: template.html,
        mixins: [mixin],
        el: vm.$refs.preview_component,
        data: () => {
          return {
            quotation: vm.quotation_in,
          };
        },
        methods: {
          moment: moment,
          update_custom: function(field = {}) {
            let _vm = this;
            if (_vm[field.name] != undefined) {
              _vm.$set(_vm, field.name, field.value);
            }
          },
        },
        mounted: function() {
          let _vm = this;
          if (template.css) {
            setTimeout(() => {
              window.jQuery(_vm.$el).append(`<style>${template.css}</style>`);
            }, 200);
          }
        },
      });
    },
    print() {
      let trgt = document.getElementById("print_element");
      PHE.printElement(trgt);
    },
    change(field) {
      let vm = this;
      if (vm.vueObject && vm.vueObject[field.name]) {
        vm.vueObject.$set(vm.vueObject, field.name, field.value);
      }
    },
    update_custom(custom_fields) {
      let vm = this;
      custom_fields.map((f) => {
        if (vm.vueObject) vm.vueObject.update_custom(f);
      });
    },
    update() {
      this.$emit("update_preview");
    },
    update_values(data) {
      let vm = this;
      data.map((f) => {
        if (vm.vueObject) vm.vueObject.update_custom(f);
      });
    },
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {},
};
</script>
